<app-layout-row>
  <app-layout-column [width]="8">
    <app-form-page pageTitle="Company Profile" [mode]="mode()" [allowEditMode]="true" [allowNewMode]="false"
      [form]="tForm" (modeChanged)="onModeChanged($event)">

      <app-page-command-group>
        <app-page-command name="edit" requiredPermissions="Settings_Action_CompanyProfile_Edit"></app-page-command>
        <app-page-command name="save" [action]="onSaveClick"></app-page-command>
        <app-page-command name="cancel" [action]="onCancelClick"></app-page-command>
      </app-page-command-group>

      <form (ngSubmit)="onSaveClick()" #tForm="ngForm">
        @if (companyProfile()) {
        <br /><br />
        <div class="company-profile-form">
          <app-textbox decorator name="name" caption="Company Name" [ngModel]="companyProfile().Name"
            [disabled]="mode() === FormMode.View" (ngModelChange)="updateName($event)">
          </app-textbox>

          <app-image-uploader
          name="logo"
          caption="Company Logo"
          [ngModel]="companyProfile().Logo"
            (ngModelChange)="updateLogo($event)"
            [showPreview]="true"
            [showRemoveButton]="true"
            [showValidationText]="true"
            [disabled]="mode() === FormMode.View"
            [minWidth]="10"
            [minHeight]="10"
            [maxWidth]="4096"
            [maxHeight]="4096"
            [maxSizeBytes]="2097152"
            [allowedTypes]="['image/png', 'image/jpeg', 'image/jpg', 'image/gif']">
          </app-image-uploader>
          <br />
          <app-checkbox decorator="right-side" name="showLogoOnPartnerPortal" caption="Show Logo on Partner Portal" [ngModel]="showLogoOnPartnerPortal()" (ngModelChange)="onShowLogoOnPartnerPortalChange($event)" [disabled]="mode() === FormMode.View"></app-checkbox>
        </div>
        }
      </form>
    </app-form-page>
  </app-layout-column>
</app-layout-row>
